module.exports = __webpack_public_path__ + "img/code1.5bdfd39d.jpeg";